<div class="modal right" id="taskDetail" tabindex="-1" role="dialog" aria-labelledby="taskDetailLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" id="print-content">
            <div class="modal-header bg-light hide-print">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title fs18" id="taskDetailLabel">Kargo No : {{ selectedWork.id }}</h4>
            </div>

            <div class="modal-body" style="background: #FBFBFA;padding: 1px;">

                <div class="loading" ng-if="loadingWork">
                    <div id="global_loader" class="glb-ldr-prt"><div class="gl-ldr-cld"><div class="gl-ldr-ctr"><div class="gl-loader"></div></div></div></div>
                </div>

                <div class="row">
                    <div class="col-md-9">
                        <div class="row mt15">
                            <div class="col-md-12">
                                <div class="detail-box">
                                    <p>
                                        <h3 ng-if="selectedWork.title.length > 0">{{ selectedWork.title }}</h3>
                                        <p>
                                            <i class="fa fa-file-text"></i> 
                                            <span ng-if="selectedWork.description && selectedWork.description !== null" ng-bind-html="selectedWork.description | trust"></span>
                                            <span ng-if="!selectedWork.description">Detay Girilmemiş</span>
                                        </p>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div ng-class="!selectedWork.customer ? 'col-md-12' : 'col-md-6'">
                                <div class="detail-box">
                                    <p class="hidden order-id">
                                        <strong>Kargo No : </strong>
                                        <span>#{{ selectedWork.id }}</span>
                                    </p>
                                    <p>
                                        <strong>KargoDurumu : </strong>
                                        <span ng-if="selectedWork.status" ng-style="{'color': selectedWork.status.color }">{{ selectedWork.status.name }}</span>
                                    </p>
                                    <p>
                                        <strong>Öncelik : </strong>
                                        <span ng-if="order.importance == 'low'" class="label label-success">Düşük</span>
                                        <span ng-if="order.importance == 'middle'" class="label label-warning">Orta</span>
                                        <span ng-if="order.importance == 'high'" class="label label-danger">Yüksek</span>
                                    </p>
                                    <p>
                                        <strong>Oluşturma Tarihi : </strong> <span>{{ selectedWork.created_at | amUtc | amDateFormat:'MM/DD/YYYY, HH:mm' }}</span>
                                    </p>
                                    <p>
                                        <strong>Kargo Tarihi : </strong> <span>{{ selectedWork.scheduled_time | amUtc | amDateFormat:'MM/DD/YYYY, HH:mm' }}</span>
                                    </p>
                                    <p>
                                        <strong>KargoSahibi : </strong> <span><i class="fa fa-user"></i> {{ selectedWork.worker.user.full_name }}</span>
                                    </p>
                                    <p>
                                        <strong>Oluşturan Kişi : </strong> <span><i class="fa fa-user"></i> {{ selectedWork.user.full_name }}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="col-md-6 mln pln print-modal-customer" ng-if="selectedWork.customer">
                                <div class="detail-box">
                                    <p>
                                        <strong>Full Name : </strong> <span><i class="fa fa-user"></i> {{ selectedWork.customer.customer_name }}</span>
                                    </p>
                                    <p>
                                        <strong>Telefon : </strong> <span><i class="fa fa-phone"></i> {{ selectedWork.customer.phone_number }}</span>
                                    </p>
                                    <p>
                                        <strong>Adres : </strong> <span><i class="fa fa-map-marker"></i> {{ selectedWork.customer.address }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <h4 class="ml15" ng-if="selectedWork.files.length > 0">Dosyalar</h4>
                        <div class="row" ng-if="selectedWork.files.length > 0">
                            <div class="col-md-12">
                                <div class="detail-box">
                                    <span class="row" >
                                        <a 
                                        href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.url }}" 
                                        ng-repeat="item in selectedWork.files"
                                        target="__BLANK">

                                            <img 
                                                ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.url }}" 
                                                ng-if="imageFormats.indexOf(getExtensions(item.url)) != -1"
                                                class="img-responsive img-thumbnail col-md-2 m5">

                                            <img 
                                                ng-src="img/word.png" 
                                                ng-if="wordFormats.indexOf(getExtensions(item.url)) != -1"
                                                class="img-responsive img-thumbnail col-md-2 m5">

                                            <img 
                                                ng-src="img/excel.png" 
                                                ng-if="excelFormats.indexOf(getExtensions(item.url)) != -1"
                                                class="img-responsive img-thumbnail col-md-2 m5">

                                            <img 
                                                ng-src="img/pdf.png" 
                                                ng-if="pdfFormats.indexOf(getExtensions(item.url)) != -1"
                                                class="img-responsive img-thumbnail col-md-2 m5">
                                                

                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="row" ng-if="selectedWork.form">
                            <div class="col-md-12">
                                <div class="detail-box">
                                    <p>
                                        <strong>Form Adı : </strong> <span> {{ selectedWork.form.name }}</span>
                                    </p>
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th class="w200 fw600">Alan Adı</th>
                                                <th class="w200 fw600">Değeri</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr ng-repeat="item in selectedWork.form.fields">
                                                <td>{{ item.field_name }}</td>
                                                <td ng-if="item.field_type == 'image'">
                                                    <a href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.value.value }}" target="__BLANK" ng-if="item.value.value.length > 0" >
                                                        <img
                                                            ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ item.value.value }}" 
                                                            class="img-thumbnail col-md-3">
                                                    </a>
                                                    <span ng-if="item.value.value.length == 0">Resim Eklenmemiş</span>
                                                </td>
                                                <td ng-if="item.field_type != 'image' && item.field_type != 'date' && item.field_type != 'checkbox'">
                                                    <span ng-if="item.value.value.length > 0">{{ item.value.value }}</span>
                                                    <span ng-if="item.value.value.length == 0">Bilgi Girilmemiş</span>
                                                </td>
                                                <td ng-if="item.field_type == 'date'">
                                                    <span ng-if="item.value.value.length > 0">{{ item.value.value | amUtc | amDateFormat:'MM/DD/YYYY' }}</span>
                                                    <span ng-if="item.value.value.length == 0">Bilgi Girilmemiş</span>
                                                </td>
                                                    
                                                <td ng-if="item.field_type == 'checkbox'">
                                                    <span ng-if="item.value.value.length > 0" ng-repeat="i in getCheckbox(item.value.value) track by $index ">{{ i }} ,</span>
                                                    <span ng-if="item.value.value.length == 0">Bilgi Girilmemiş</span>
                                                </td>
                                                    
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <h4 class="ml15">Notlar</h4>
                        <div class="row">
                            <div class="col-md-12">
                                <textarea rows="3" cols="15"
                                    ng-model="description" 
                                    id="noteInput"
                                    class="form-control input-sm chat_input hide-print" 
                                    placeholder="Notunuzu yazınız..." 
                                    ng-disabled="noteAdding">
                                </textarea>
                                <a href="#" ng-click="sendComment(description)" class="mt10 btn btn-primary hide-print">Gönder</a>
                            </div>
                            <div class="col-md-12 scroll-task">
                                <div class="mt10" ng-repeat="comment in selectedWork.comments">
                                    <div class="messages msg_receive">
                                        <p>
                                            <strong>{{ comment.user.full_name }}</strong>
                                            <small class="pull-right">{{ comment.created_at | amUtc | amDateFormat:'MM/DD/YYYY, HH:mm' }}</small>
                                        </p>
                                        <p>{{ comment.description }}</p>
                                    </div>
                                </div>
                                <div class="mt10" ng-if="selectedWork.comments.length == 0" >
                                    <div class="messages msg_receive">
                                        <p>Henüz bu iş için bir not girilmedi.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <h4 class="ml15 mt15">Aktiviteler</h4>
                        <div id="timeline" class="mt15 timeline-single">
                            <div class="row">
                                <div class="col-sm-6 left-column">
                                    <div class="timeline-item" ng-repeat="log in selectedWork.logs | filter: { proccess: '!note' }">
                                        <div class="timeline-icon">
                                            <span class="fa fa-tasks text-success"></span>
                                        </div>
                                        <div class="detail-box">
                                            <div class="row">
                                                <div class="col-md-12" ng-if="!$last">
                                                    <span ng-if="log.proccess != 'rate'"><strong>{{ log.user.full_name }}</strong> tarafından iş durumu </span> 
                                                    <span ng-if="log.proccess == 'rate'">Müşteri tarafından </span> 
                                                    
                                                    <strong 
                                                        ng-if="log.step" 
                                                        ng-style="{'color': log.step.color }">
                                                        "{{ log.step.name }}"
                                                    </strong>

                                                    <span ng-if="log.proccess != 'rate'">olarak değiştirildi. </span> 
                                                    
                                                    <p ng-if="log.proccess == 'rate'">
                                                        <i class="fa fa-star"></i> {{ selectedWork.rate }} Puan verildi. <br>
                                                        <strong>Yorum : {{ log.reason ? log.reason : 'Yorum Yapılmadı.' }}</strong>
                                                    </p>
                                                    <hr class="m5">
                                                    <small class="pull-right text-right">
                                                        <i class="fa fa-clock-o"></i> 
                                                        {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                        {{ log.created_at | amUtc | amDateFormat:'HH:mm' }}
                                                    </small>
                                                </div>
                                                <div class="col-md-12" ng-if="$last">
                                                    <span><strong>{{ log.user.full_name }}</strong> tarafından iş <strong>oluşturuldu</strong>. </span> 
                                                    <hr class="m5">
                                                    <small class="pull-right text-right">
                                                        <i class="fa fa-clock-o"></i> 
                                                        {{ log.created_at | amUtc | amDateFormat:'MM/DD/YYYY' }},
                                                        {{ log.created_at | amUtc | amDateFormat:'HH:mm' }}
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="timeline-item" ng-if="selectedWork.logs.length == 0">
                                        <div class="timeline-icon">
                                            <span class="fa fa-times"></span>
                                        </div>
                                        <div class="detail-box">
                                            <div class="row">
                                                <div class="col-md-12">
                                                    <span>Henüz Aktivite Bulunamadı!</span> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-3 mt20 pr25 pln hide-print">
                        <a href="#" data-dismiss="modal" data-toggle="modal" data-target="#newTask" ng-click="updateTask()" class="btn btn-block btn-primary mb15">
                            <i class="fa fa-pencil"></i> Düzenle
                        </a>
                        <a href="#" data-dismiss="modal" data-toggle="modal" data-target="#deleteTask" class="btn btn-block btn-warning mb15">
                            <i class="fa fa-trash"></i> Sil
                        </a>
                        <a href="#" class="btn btn-block btn-info" ng-click="print()">
                            <i class="fa fa-print"></i> Yazdır
                        </a>
                        <ul class="list-group mt20">
                            <li class="list-group-item" ng-repeat="item in selectedWork.notifications">
                                <i class="fa fa-bell-o"></i> 
                                {{ item.time }}
                                <span ng-if="item.period == 'minute'">Dk</span>
                                <span ng-if="item.period == 'hour'">Saat</span>
                                <span ng-if="item.period == 'day'">Gün</span>
                                önce
                                <span ng-if="item.type == 'email'">Email</span>
                                <span ng-if="item.type == 'sms'">Sms</span>
                                ile

                                <!--
                                    <a href="" class="pull-right"><i class="fa fa-delete"></i></a>
                                -->
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="modal-footer bg-light hide-print">
                <button type="button" class="btn btn-default" data-dismiss="modal">Kapat</button>
            </div>

        </div>
    </div>
</div>